module.exports = __webpack_public_path__ + "img/edge_activites_moto.f37749ce.svg";